<!-- Hero Section -->
<section class="about-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">SAFROO</h1>
    <p class="hero-subtitle">Experience the World</p>
  </div>
</section>

<!-- About Content Section -->
<section class="about-content-section">
  <div class="content-container">
    <!-- Left Side - Founded Badge and Description -->
    <div class="left-content">
      <div class="founded-badge">
        <span class="founded-text">Founded</span>
        <span class="founded-year">2024</span>
      </div>
      
      <div class="description-text">
        <p>
          Safroo was created from a simple belief: the best travel memories are 
          made with locals, not tour buses. We are a community-driven mobile 
          platform that connects curious travelers directly with verified, 
          passionate local experts and hosts. We cut through the mass-market 
          noise to deliver experiences that are authentic, deeply cultural, and 
          respectful of the communities they serve.
        </p>
      </div>
    </div>

    <!-- Right Side - Image with About Us Label -->
    <div class="right-content">
      <div class="about-image-container">
        <img src="assets/AboutUs/ManOnRock.jpg" alt="Man on Rock" class="about-image" />
        <div class="about-label">About Us</div>
      </div>
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="features-section">
  <div class="features-container">
    <div class="feature-card">
      <div class="feature-icon">
        <img src="assets/AboutUs/LocationVector.png" alt="Location Icon" />
      </div>
      <h3 class="feature-title">Search Destinations</h3>
      <p class="feature-description">
        We guarantee every experience is manually verified by our team.
      </p>
    </div>

    <div class="feature-card">
      <div class="feature-icon">
        <img src="assets/AboutUs/LocationVector.png" alt="Location Icon" />
      </div>
      <h3 class="feature-title">Search Destinations</h3>
      <p class="feature-description">
        Every booking is 100% independent. No tour buses, no scripts, just you and your guide.
      </p>
    </div>

    <div class="feature-card">
      <div class="feature-icon">
        <img src="assets/AboutUs/LocationVector.png" alt="Location Icon" />
      </div>
      <h3 class="feature-title">Search Destinations</h3>
      <p class="feature-description">
        You decide exactly what you see is exactly what you get.
      </p>
    </div>

    <div class="feature-card">
      <div class="feature-icon">
        <img src="assets/AboutUs/LocationVector.png" alt="Location Icon" />
      </div>
      <h3 class="feature-title">Search Destinations</h3>
      <p class="feature-description">
        Our award-winning app makes finding, chatting, and booking seamless.
      </p>
    </div>
  </div>
</section>

<!-- Community Built on Trust Section -->
<section class="community-section">
  <div class="community-container">
    <!-- Left Side - Images -->
    <div class="community-images">
      <div class="back-plate-turquoise"></div>
      <div class="hands-image-wrapper">
        <img src="assets/AboutUs/HandOnHand.jpg" alt="Hands Holding" class="hands-image" />
      </div>
      <div class="group-map-overlay">
        <img src="assets/AboutUs/Groupwithmap.jpg" alt="Group with Map" class="group-image" />
      </div>
    </div>

    <!-- Right Side - Content -->

    <div class="community-content">
      <div class="stars-badge">5 Stars Rated</div>
      
      <h2 class="community-title">
        A Community <span class="highlight-blue">Built<br />on Trust</span>
      </h2>
      
      <p class="community-description">
        We are proud of the community we've built. Since launching, we have 
        empowered hundreds of local guides and facilitated thousands of 
        genuine cultural exchanges. Our commitment to human curation and 
        local empowerment is why we maintain a high user satisfaction rating 
        across our booking categories. We are driven by the stories we help 
        create, both for the traveler and the local host.
      </p>
    </div>
  </div>
</section>

<!-- Mission Section -->
<section class="mission-section">
  <div class="mission-container">
    <!-- Left Side - Content -->
    <div class="mission-content">
      <h2 class="mission-title">
        The Safroo Mission:<br />
        <span class="highlight-teal">Authentic Connection</span>
      </h2>
      
      <h3 class="mission-subtitle">Our Vision for the Future of Travel</h3>
      
      <p class="mission-description">
        We envision a travel ecosystem where every journey is meaningful, 
        respectful, and economically beneficial to the hosting communities. We 
        believe the future lies not in bigger resorts or cheaper package 
        deals, but in connecting two people - a traveler and a local - to share a 
        moment of genuine culture. This is the heart of Safroo: facilitating 
        authentic, human-to-human connection that changes perspectives, 
        one experience at a time.
      </p>
    </div>

    <!-- Right Side - Images -->
    <div class="mission-images">
      <div class="mission-bg">
        <img src="assets/AboutUs/BgMobileEntrance.jpg" alt="Background" class="bg-mobile-image" />
      </div>
      <div class="phone-screen">
        <img src="assets/AboutUs/MobileEntrance.jpg" alt="Mobile Entrance" class="mobile-entrance-image" />
      </div>
      <div class="corner-accent-bottom"></div>
      <div class="corner-accent-right"></div>
    </div>
  </div>
</section>
